import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
    card: {
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        boxSizing: 'border-box',
    },
    cardTop: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '12px',
    },
    iconContainer: {
        width: '40px',
        height: '40px',
        borderRadius: '8px',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        flexShrink: 0,
    },
    iconImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    iconInitials: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#555555',
        letterSpacing: '0.5px',
    },
    typeLabel: {
        fontSize: '11px',
        fontWeight: 500,
        color: '#9e9e9e',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
    },
    appName: {
        fontSize: '15px',
        fontWeight: 700,
        color: '#212121',
        marginBottom: '6px',
    },
    description: {
        fontSize: '13px',
        color: '#757575',
        lineHeight: 1.5,
        marginBottom: '16px',
        flexGrow: 1,
    },
    viewButton: {
        borderRadius: '20px',
        border: '1px solid #bdbdbd',
        padding: '4px 20px',
        fontSize: '13px',
        fontWeight: 500,
        color: '#424242',
        textTransform: 'none',
        alignSelf: 'flex-start',
        '&:hover': {
            backgroundColor: '#f5f5f5',
            border: '1px solid #9e9e9e',
        },
    },
});

export default styles;
export const useStyles = makeStyles(styles);
